<template>
    <div class="animated fadeIn">
        <div>
            <component-header
                :title="`${orgoName} - Wallet Statement`"
                @reload-data="getPartnerWalletListData"
                :isLoading="isloading"
                :hasCreate="false"
                :hasback="true"
                @back-press="$router.push('/partner')"
                :hasSearch="false"
            />
            <div class="my-3">
                <b-row class="mx-3">
                    <b-col md="6">
                        <b-row>
                            <b-col md="6">
                                <b-row>
                                    <b-col class="wallet-font"
                                        ><b class="ml-n3"> Wallet Balence : </b>
                                        <strong
                                            :class="`ml-1 ${
                                                walletBalence < 0
                                                    ? 'text-danger'
                                                    : 'text-success'
                                            }`"
                                        >
                                            ₹ {{ this.walletBalence }}
                                        </strong>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col md="6">
                        <b-row>
                            <b-col md="5">
                                <b-input
                                    id="start-date"
                                    type="date"
                                    v-model="walletStartDate"
                                ></b-input>
                            </b-col>
                            <b-col md="5">
                                <b-input
                                    id="end-date"
                                    type="date"
                                    v-model="walletEndDate"
                                ></b-input>
                            </b-col>
                            <b-col md="2">
                                <b-button
                                    @click="findWalletStatementData"
                                    size="sm"
                                    variant="primary"
                                    class="my-2 mr-2 my-sm-0"
                                    >Find</b-button
                                >
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </div>
            <b-card class="card-wrap" border-variant="info">
                <div>
                    <b-table
                        :dark="false"
                        :hover="true"
                        :striped="false"
                        :bordered="true"
                        :small="false"
                        :fixed="false"
                        responsive="sm"
                        :items="walletList"
                        :fields="walletColumns"
                        :current-page="currentPage"
                        :per-page="perPage"
                        thead-class="header"
                        show-empty
                    >
                        <template slot="cell(action)" slot-scope="data">
                            <p v-if="data.item.action == 'C'">
                                <v-avatar size="23">
                                    <img
                                        class="mr-1"
                                        src="img/Credit.png"
                                        alt=""
                                    />
                                </v-avatar>
                                Credited
                            </p>
                            <p v-if="data.item.action == 'D'">
                                <v-avatar size="23">
                                    <img src="img/Debit.png" alt="" />
                                </v-avatar>
                                Debited
                            </p>
                        </template>
                        <template slot="cell(empty)">
                            <div v-if="isloading" class="text-center">
                                <span><b>Loading...</b></span>
                            </div>
                            <div v-else class="text-center">
                                No data available.
                            </div>
                        </template>
                    </b-table>
                </div>
                <div style="float: right">
                    <b-pagination
                        v-model="currentPage"
                        :per-page="perPage"
                        :total-rows="walletList.length"
                        aria-controls="my-table"
                        prev-text="Prev"
                        next-text="Next"
                        hide-goto-end-buttons
                    ></b-pagination>
                </div>
            </b-card>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import ebButton from "@/components/FormElements/Button";
import ComponentHeader from "@/components/componentNewHeader";
import loader from "@/components/loader/nipigeloader.vue";
import moment from "moment";
export default {
    name: "WalletStatement",
    components: {
        ebButton,
        ComponentHeader,
        loader,
    },
    data() {
        return {
            walletStartDate: "",
            walletEndDate: "",
            isloading: false,
            currentPage: 1,
            perPage: 10,
            walletColumns: [
                {
                    key: "id",
                },
                {
                    key: "amount",
                },
                {
                    key: "date",
                },
                {
                    key: "description",
                },
                {
                    key: "currentBalence",
                },
                {
                    key: "action",
                },
            ],
        };
    },

    computed: {
        ...mapGetters({
            partnerAllData: "partner/GetPartnerData",
            getWalletList: "walletstatement/GetWalletList",
        }),
        orgoName() {
            try {
                if (
                    this.partnerAllData.organization &&
                    this.partnerAllData.organization.name
                ) {
                    return this.partnerAllData.organization.name;
                } else {
                    return "Not Avilable";
                }
            } catch (err) {
                return "Not Avilable";
            }
        },
        walletBalence() {
            try {
                if (
                    this.getWalletList.wallet &&
                    this.getWalletList.wallet.balance
                ) {
                    return this.getWalletList.wallet.balance;
                } else {
                    if (this.getWalletList.wallet.balance == 0) {
                        return this.getWalletList.wallet.balance;
                    } else {
                        return "Not Available";
                    }
                }
            } catch (err) {}
        },
        walletList() {
            try {
                let data = this.getWalletList.history.sort(
                    (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt),
                );

                let walletTableList = [];
                if (Array.isArray(data) && data.length > 0) {
                    data.map((obj) => {
                        let arrObj = {
                            id: obj.transRefNo,
                            amount: obj.amount,
                            date: this.getProperDate(obj.createdAt),
                            description: obj.description,
                            currentBalence: this.decideCurrentBalence(
                                obj.action,
                                obj.oldBalance,
                                obj.amount,
                            ),
                            action: obj.action,
                        };
                        walletTableList.push(arrObj);
                    });
                    return walletTableList;
                } else {
                    return walletTableList;
                }
            } catch (err) {
                return [];
            }
        },
    },
    methods: {
        decideCurrentBalence(action, oldBalence, amount) {
            if (action == "C") {
                return oldBalence + amount;
            } else if (action == "D") {
                return oldBalence - amount;
            } else {
                return "Unavailable";
            }
        },
        getProperDate(data) {
            if (data != null) {
                let date = new Date(data);
                return moment(String(date)).format("DD/MM/YYYY");
            } else {
                return "Unavailable";
            }
        },
        async getPartnerWalletListData() {
            this.isloading = true;
            let payLoad = {
                customerId: this.partnerAllData._id,
            };
            await this.$store.dispatch(
                "walletstatement/fetchWalletListAll",
                payLoad,
            );
            this.isloading = false;
        },
        async findWalletStatementData() {
            this.isloading = true;
            let payload = {
                from: this.walletStartDate,
                to: this.walletEndDate,
                data: {
                    customerId: this.partnerAllData._id,
                },
            };
            await this.$store.dispatch(
                "walletstatement/fetchWalletList",
                payload,
            );
            this.isloading = false;
        },
    },
    async mounted() {
        if (this.partnerAllData == null) {
            await this.$store.dispatch(
                "partner/fetchPartnerById",
                this.$route.params.id,
            );
        }
        this.isloading = true;
        let payLoad = {
            customerId: this.partnerAllData._id,
        };
        await this.$store.dispatch(
            "walletstatement/fetchWalletListAll",
            payLoad,
        );

        this.isloading = false;
    },
};
</script>
<style scoped>
.wallet-font {
    font-size: 17px;
}
</style>
